import {Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {DtoImportObjectContext} from "../../../../../core/shared/dto/dto.import.object.context";
import {WidgetData} from "../../../../../core/shared/widget/widget-data";
import {MvsObjectNavigationService} from "../../../../../core/shared/navigation/mvs-object-navigation.service";
import {
    MvsObjectNavigationProviderGeneric
} from "../../../../../core/shared/navigation/impl/mvs-object-navigation-provider-generic";
import {FilterCriteria} from "../../../../../core/shared/filter/api/filter.criteria";
import {Sorting} from "../../../../../core/shared/misc/sorting";
import {PagingDto} from "../../../../../core/shared/dto/model/paging.dto";
import {WidgetFactory} from "../../../../../core/shared/widget/service/widget.factory";
import {WidgetDataParam} from "../../../../../core/shared/widget/widget-data-param";
import {MvsObjectNavigationEntry} from "../../../../../core/shared/navigation/mvs-object-navigation-entry";
import {MvsObjectNavigationActionEnum} from "../../../../../core/shared/navigation/mvs-object-navigation-action-enum";
import {QlQueryDto} from "../../../../../core/shared/ql/data/dto/ql-query.dto";

// NOT_IN_USE_CURRENTLY
@Component({
    selector: 'mvs-my-tickets',
    templateUrl: './my-tickets.component.html',
    standalone: false
})
export class MyTicketsComponent implements OnInit, OnChanges, OnDestroy {

    busy: boolean;  // indicator whether the component is busy
    initialized: boolean; // indicator whether the component was initialized

    @Input() agentId: number;
    @Input() importObjectContextDto: DtoImportObjectContext;


    widgetTicketTableMe: WidgetData;

    constructor(protected navigationService: MvsObjectNavigationService) {
    }

    ngOnInit(): void {

        // to open ticket drawer
        this.navigationService.setNavigationProvider(new MvsObjectNavigationProviderGeneric());

        this.initComponent();
        this.refreshComponent();
    }

    /**
     * Initialize Component.
     */
    initComponent() {
        const alias = "tm.dashboard.me.tickets";
        const qlQueryDto: QlQueryDto = {
            name: alias,
            type: "view",
            filters: [FilterCriteria.create("aa.id", FilterCriteria.cOperatorEqual, this.agentId)],
            sortings: [new Sorting("dueDate", true)],
            paging: PagingDto.create(0, 5),
            start: {
                name: 'tm.Ticket',
                as: 't',
                type: 'entity',
                joins: [
                    {
                        joinType: "left",
                        type: "entity",
                        name: "assigneeAgent",
                        as: "aa",
                    }
                ]
            }
        };

        this.widgetTicketTableMe = WidgetFactory.createWidgetListQl(
            alias,
            'Meine Tickets',
            'table',
            qlQueryDto);
        this.widgetTicketTableMe.setParam(WidgetDataParam.create('selectionMode', 'single'));
        this.widgetTicketTableMe.setParam(WidgetDataParam.create('size', 'S'));
    }

    /**
     * Refresh Component.
     */
    refreshComponent() {
        this.initialized = true;
    }

    onTicketSelect(object: any) {

        this.openTicketDrawer(object.objectId);
    }

    openTicketDrawer(ticketId: number) {
        const mvsObjectNavigationEntry = MvsObjectNavigationEntry.createNavigationEntry("tm.Ticket", ticketId, "Ticekt", null, null,null, MvsObjectNavigationActionEnum.any);
        this.navigationService.navigateTo(mvsObjectNavigationEntry, 'right');
    }

    /**
     * Process changes within Binding.
     * @param changes
     */
    ngOnChanges(changes: SimpleChanges): void {

        if (!this.initialized) {
            return;
        }

        if (changes["id"]) {
            this.refreshComponent();
        }
    }

    /**
     * Destroy component.
     */
    ngOnDestroy(): void {

    }
}
